import { Model } from '@app/models/model';
import { User } from '@app/models/users/users.model';
import { Device } from '@app/models/devices/devices.model';
import { config } from '@config/config';

export class Location extends Model {
    // Backend fields
    id: number;
    name: string;
    primary_location: boolean;
    address: string;
    address_2: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
    geo: {
        x: number;
        y: number;
    };
    tz: string;
    installation: string;
    user_id: number;
    profile?: {
        residents: number;
        bathrooms: number;
        faucet: boolean;
        toilet: boolean;
        shower: boolean;
        bathtub: boolean;
        clothes_washer: boolean;
        dish_washer: boolean;
        water_softener: boolean;
        water_filter: boolean;
        ice_maker: boolean;
        humidifier: boolean;
        sprinklers: boolean;
        hose_irrigation: boolean;
        drip_irrigation: boolean;
        soaker_hose: boolean;
        pool: boolean;
    };
    usage_profile: {
        id: number;
        residents: string;
        score: number;
        bathrooms: string;
        irrigation: string;
        irrigation_freq: string;
        irrigation_max_cycle: number;
        has_pool: boolean;
    };
    features: {
        disaggregation: string;
        monthly_emails: boolean;
        auto_survey: string;
        last_survey_created_datetime?: string;
        use_profile_for_disag: boolean;
    };
    away_mode: boolean;
    building_type: string;
    insurer_id: number;

    // Frontend fields
    user: User;
    bridge: Device;
    ws: Device;
    streetAddress: string;
    overallStatus: string;

    get fullAddress() {
        if (this.address_2) {
            this.streetAddress = this.address + ', ' + this.address_2;
        } else {
            this.streetAddress = this.address;
        }
        return `${this.streetAddress}, ${this.city} ${this.state} ${this.postal_code}`;
    }

    get status() {
        return config.locationStatus[this.installation];
    }

    calculateOverallStatus() {
        if (this.status === 'Active' && this.ws && !this.ws.connected) {
            this.overallStatus = 'Offline';
        } else if (this.status === 'Active' && !this.ws) {
            this.overallStatus = config.locationStatus['NOT_STARTED'];
        } else {
            this.overallStatus = this.status;
        }
    }
}

interface IndoorAppliances {
    field: string;
    display: string;
    default: boolean;
}
interface OutdoorAppliances {
    field: string;
    display: string;
    default: boolean;
}

export class LocationAppliances extends Model {
    residents: {
        display: string;
    };
    bathrooms: {
        display: string;
    };
    indoor: IndoorAppliances[];
    outdoor: OutdoorAppliances[];
}
